import { createAction, createAsyncAction } from "typesafe-actions";
import { UserResponse } from "../../models/users";
import { Token } from "./../../models/users";

export const setAuthToken = createAction("SET_AUTH_TOKEN")<string>();

export const logout = createAction("LOGOUT")();

export const fetchSelfAsync = createAsyncAction(
  "@USER/FETCH_SELF_REQUEST",
  "@USER/FETCH_SELF_SUCCESS",
  "@USER/FETCH_SELF_FAILURE"
)<undefined, UserResponse, string>();

export const loginAsync = createAsyncAction(
  "@USER/LOGIN_REQUEST",
  "@USER/LOGIN_SUCCESS",
  "@USER/LOGIN_FAILURE"
)<{ email: string; password: string; token: string }, Token, string>();

export const loginClear = createAction("@USER/LOGIN_CLEAR")();

export const createUserAsync = createAsyncAction(
  "@USER/CREATE_USER_REQUEST",
  "@USER/CREATE_USER_SUCCESS",
  "@USER/CREATE_USER_FAILURE"
)<
  {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    token: string;
  },
  Token,
  string
>();
export const createUserClear = createAction("@USER/CREATE_USER_CLEAR")();
